// extracted by mini-css-extract-plugin
export var modalFooter = "_rc-0";